import { render, staticRenderFns } from "./spars-list.vue?vue&type=template&id=6b82b906&scoped=true&"
import script from "./spars-list.vue?vue&type=script&lang=js&"
export * from "./spars-list.vue?vue&type=script&lang=js&"
import style0 from "./spars-list.vue?vue&type=style&index=0&id=6b82b906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82b906",
  null
  
)

export default component.exports